import { CircularProgress } from "@mui/material"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { CustomDataGrid, ProgressWrapper } from "components/common-styles"
import PaperComponent from "components/common/paper-component"
import { useEffect } from "react"
import { useStores } from "stores/root-store"
import { formatDisplayDate, formatStandardDate } from "utils/date-helper"
import { rootStore } from "stores/root-store"
import { observer } from "mobx-react-lite"
import { trackEvent } from "utils/analytics"

const UploadHistoryDialog = ({ moduleName, open, onClose }) => {
  const { FileUploadHistoryStore } = useStores()

  const columns = [
    {
      field: "FileName",
      headerName: "File Name",
      flex: 1,
      minWidth: 200,
      renderCell: params => {
        if (!params.row.FileContent) return params.value

        return (
          <a
            href="#"
            onClick={e => {
              e.preventDefault()

              handleDownload(params.row.FileContent, params.value)
            }}
          >
            {params.value}
          </a>
        )
      },
    },
    {
      field: "DateTimeStamp",
      headerName: "Upload Time",
      width: 180,
      renderCell: params => {
        return formatStandardDate(params.value)
      },
    },
    {
      field: "UploadResult",
      headerName: "Upload Result",
      flex: 1,
      minWidth: 200,
    },
  ]

  // Function to handle file download
  const handleDownload = (base64Data, fileName) => {
    let mimeType = "text/csv"
    const fileNameLowerCase = fileName ? fileName.toLowerCase() : ""
    if (fileNameLowerCase.indexOf(".xlsx")) mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    else if (fileNameLowerCase.indexOf(".xls")) mimeType = "application/vnd.ms-excel"

    const binaryData = atob(base64Data) // Decode Base64
    const byteNumbers = new Uint8Array(binaryData.length)

    for (let i = 0; i < binaryData.length; i++) {
      byteNumbers[i] = binaryData.charCodeAt(i)
    }

    const blob = new Blob([byteNumbers], { type: mimeType }) // Create Blob
    const url = URL.createObjectURL(blob)

    const a = document.createElement("a")
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    trackEvent("export", { entity: "upload_history", format: (fileNameLowerCase.split(".").pop() || "").slice(0, 10) })
  }

  useEffect(() => {
    FileUploadHistoryStore.loadData(rootStore.userEmail, moduleName)
  }, [])

  return (
    <Dialog open={open} onClose={onClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title" maxWidth="lg">
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        Upload History
      </DialogTitle>
      <DialogContent dividers style={{ display: "flex", flex: 1, justifyContent: "center" }}>
        {FileUploadHistoryStore.isLoading ? (
          <ProgressWrapper>
            <CircularProgress size={64} />
          </ProgressWrapper>
        ) : (
          <CustomDataGrid
            style={{ width: 800, height: 400 }}
            getRowId={row => row.DateTimeStamp}
            rows={FileUploadHistoryStore.data || []}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 15,
                },
              },
            }}
            pageSizeOptions={[15, 20, 50]}
            disableRowSelectionOnClick
          />
        )}
      </DialogContent>
    </Dialog>
  )
}

export default observer(UploadHistoryDialog)
